"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _gerenciatdFormskeleton = _interopRequireDefault(require("@bit/gerenciatd.formskeleton.form-skeleton"));

var _C2CEmpresas = _interopRequireDefault(require("./C2CEmpresas"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ModalC2CEmp = _ref => {
  let {
    Modal,
    taggingInfo,
    tipoTes,
    destino,
    tes,
    fixedCampaign,
    fixedProduct
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdFormskeleton.default, {
    name: "FormC2C",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_C2CEmpresas.default, {
      Modal: Modal,
      taggingInfo: taggingInfo,
      tipoTes: tipoTes,
      destino: destino,
      tes: tes,
      fixedCampaign: fixedCampaign,
      fixedProduct: fixedProduct
    })
  });
};

var _default = ModalC2CEmp;
exports.default = _default;

//# sourceMappingURL=index.js.map